var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feedback-success-page" }, [
    _c(
      "div",
      { staticClass: "page-head" },
      [
        _c("van-icon", {
          staticClass: "back",
          attrs: { name: "arrow-left" },
          on: {
            click: function($event) {
              return _vm.$router.back()
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("m.submitted_successfully")))
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "center-wrap" },
        [
          _c("div", { staticClass: "check-circle" }, [
            _c("img", {
              staticClass: "check-icon",
              attrs: { src: _vm.tick, alt: "tick" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "succ-title" }, [
            _vm._v(_vm._s(_vm.$t("m.submitted_successfully")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "succ-desc" }, [
            _vm._v(_vm._s(_vm.$t("m.feedback_success_tip")))
          ]),
          _vm._v(" "),
          _c(
            "van-button",
            {
              staticClass: "done-button",
              attrs: { type: "primary" },
              on: { click: _vm.onDone }
            },
            [_vm._v(_vm._s(_vm.$t("m.completed")))]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f320a62c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f320a62c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/feedbackSuccess.vue
// module id = null
// module chunks = 